/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_YesInputs */

const en_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const de_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const fr_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const es_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const it_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

const nl_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const pl_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak`)
};

const fi_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyllä`)
};

const da_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const sv_pricing_compare_yes = /** @type {(inputs: Pricing_Compare_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Pricing_Compare_YesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_yes = /** @type {((inputs?: Pricing_Compare_YesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_YesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_yes(inputs)
	if (locale === "fr") return fr_pricing_compare_yes(inputs)
	if (locale === "es") return es_pricing_compare_yes(inputs)
	if (locale === "it") return it_pricing_compare_yes(inputs)
	if (locale === "nl") return nl_pricing_compare_yes(inputs)
	if (locale === "pl") return pl_pricing_compare_yes(inputs)
	if (locale === "fi") return fi_pricing_compare_yes(inputs)
	if (locale === "da") return da_pricing_compare_yes(inputs)
	if (locale === "sv") return sv_pricing_compare_yes(inputs)
	return en_pricing_compare_yes(inputs)
});